var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Impostazioni',{attrs:{"show_gestione_reparto":true,"rotta_back":'/home/electrical'}})
}
var staticRenderFns = []

export { render, staticRenderFns }